import ApiClient from './ApiClient';

class CampaignTemplatesAPI extends ApiClient {
  constructor() {
    super('campaign_templates', { accountScoped: true });
  }
}

export default new CampaignTemplatesAPI();
